import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { Model } from 'app/model/backendmodel';

import { Metamodel } from 'app/model/base/model';
import { ZohoObjectDataset } from 'app/model/dataset/zoho.dataset';
import { TabularTypeDatasetAdapter, tabularTypeDatasetAdapts } from './tabular-type.dataset.adapter';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(ZohoObjectDataset),
    asynchronous: true,
    adapts: tabularTypeDatasetAdapts
})
export class ZohoObjectDatasetAdapter extends TabularTypeDatasetAdapter<ZohoObjectDataset, Model.DatasetResource> {
    protected async _toResource(dataset: ZohoObjectDataset): Promise<Model.DatasetResource> {
        return await this._toResourceInternal(dataset, Metamodel.modelFor(ZohoObjectDataset).name);
    }

    protected async _toModel(modelDatasetResource: Model.DatasetResource, dataset?: ZohoObjectDataset): Promise<ZohoObjectDataset> {
        return await this._toModelInternal(modelDatasetResource, dataset, ZohoObjectDataset.MODEL);
    }
}
